import * as React from 'react';
const LegacySelectContext = /*#__PURE__*/React.createContext(null);
export default LegacySelectContext;